/**
 * QuickCreateTaskForm - Wrapper for creating tasks via the quick create menu.
 *
 * Uses the Linear-inspired TaskQuickCreateDialog centered modal.
 */

import { TaskQuickCreateDialog } from '../../modules/tasks/components/TaskQuickCreateDialog';
import type { EntityFormProps } from './entityFormRegistry';

interface QuickCreateTaskFormProps extends EntityFormProps {
  boardId?: string;
}

export function QuickCreateTaskForm({ open, onClose, boardId }: QuickCreateTaskFormProps) {
  return (
    <TaskQuickCreateDialog
      open={open}
      onClose={onClose}
      boardId={boardId}
    />
  );
}
